// DS6.7
// DS6.7.2 (isRecommended)
// DS6.7.4 (ideaBackground)
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink, {
  Props as PlainButtonOrLinkProps,
} from '../../Buttons/PlainButtonOrLink';
import Add from '../../Icons/16x16/Add';
import { IconSize } from '../../Icons/IconWrap';
import s from './Tag.scss';

export interface Props extends PlainButtonOrLinkProps {
  size: 'small' | 'medium';
  isSelected?: boolean;
  /** Proceeds the supplied children. Consider supplying an icon. */
  postfix?: React.ReactNode;
  className?: string;
  /** truncate tag text w/ ellipsis */
  isTruncated?: boolean;
  /** recommended at submit time */
  isRecommended?: boolean;
  /** project idea tag background */
  ideaBackground?:
    | 'light-blue'
    | 'purple'
    | 'blue'
    | 'pink'
    | 'orange'
    | 'gold'
    | 'green';
}

/**
 * A tag for use with our `<InputField />` and related components.
 *
 * This will render a `<span>` or `<PlainButtonOrLink />` depending on if `onClick` is passed.
 */
const Tag: React.FC<Props> = ({
  children,
  size,
  postfix: postfixProp,
  className,
  onClick,
  href,
  isSelected,
  disabled,
  isTruncated,
  isRecommended,
  ideaBackground,
  ...rest
}) => {
  const ElementTag = !onClick && !href ? 'span' : PlainButtonOrLink;
  const postfix = isRecommended ? (
    <Add size={IconSize.SMALLER} disableDefaultColors />
  ) : (
    postfixProp
  );

  return (
    <ElementTag
      className={c(
        s['root'],
        'ds-card',
        isSelected && 'ds-card-selected',
        disabled && s['disabled'],
        s[size],
        isTruncated && s['truncated'],
        isRecommended && s['recommended'],
        ideaBackground && s['idea'],
        ideaBackground && s[`idea-${ideaBackground}`],
        className
      )}
      href={href}
      onClick={onClick}
      {...rest}
    >
      {isTruncated ? (
        <span className={s['truncated-contents']}>{children}</span>
      ) : (
        children
      )}
      {postfix && <span className={s['postfix']}>{postfix}</span>}
    </ElementTag>
  );
};
Tag.displayName = 'Tag';

export default Tag;
